import { Component, input } from '@angular/core';

@Component({
  selector: 'lib-card',
  templateUrl: './card.component.html',
})
export class CardComponent {
  readonly showHeader = input(true);
}
